'use client';

import { useLocalStorageValue } from '@react-hookz/web';
import { useHasMounted } from 'hooks/use-has-mounted';
import { Button } from 'ui';

export function AppCookieConsent({ isEU }: { isEU: boolean }) {
  const { setCookieConsent, isChosen } = useAppCookieConsent();
  const hasMounted = useHasMounted();
  if (!hasMounted) {
    return <></>;
  }
  if (!isEU || isChosen) {
    return <></>;
  }
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-center p-4">
      <div className="border-border w-full max-w-4xl rounded-lg border bg-white p-4 shadow-2xl md:p-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div className="flex-1">
            <h2 className="mb-2 text-lg font-semibold text-primary">
              We Value Your Privacy
            </h2>
            <p className="text-sm text-tertiary">
              We use cookies to enhance your experience.{' '}
              <strong>Essential</strong> cookies are required for basic site
              functionality like authentication.
              <strong> All</strong> cookies include chat widget, analytics and
              affiliate tracking cookies.
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2 sm:flex-col sm:items-stretch">
            <Button
              variant="default"
              onClick={() => {
                setCookieConsent('all');
              }}
            >
              Accept All
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setCookieConsent('essential');
              }}
            >
              Accept Essential
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function useAppCookieConsent() {
  const { value: cookieConsent, set: setCookieConsent } = useLocalStorageValue<
    'all' | 'essential' | null
  >('app-cookie-consent', {
    defaultValue: null,
  });
  return {
    setCookieConsent,
    isChosen: cookieConsent !== null,
    isAcceptedAll: cookieConsent === 'all',
    isAcceptedEssential: cookieConsent === 'essential',
  };
}
